import React, { useContext, useEffect,useState } from 'react'
import { Link } from 'react-router-dom'

import { Div, IconButton, Input, ToolTip } from '@driftt/tide-core'

import { DeserializedSavedFilter } from 'api'
import { getDefaultRange } from 'components/DateRangePicker'
import { FiltersContext } from 'context/filtersContext'
import CCRMFiltersCard from 'sections/CCRM/FiltersCard'

import styles from './styles.module.css'

interface Props {
  activeFilter: DeserializedSavedFilter | undefined
  onOpenEditModal: () => void
  setActiveFilterId: (id: number | undefined) => void
}

const CCRMHeaderBar = (props: Props) => {
  const { activeFilter } = props
  const [showFiltersCard, setShowFiltersCard] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const { searchQuery, setSearchQuery, setDateRange, dateRange } = useContext(FiltersContext)

  useEffect(() => {
    const interval = setInterval(() => {
      setSearchQuery(searchValue)

      // Clear date range, if present, and value input value is present
      if (dateRange && searchValue) {
        setDateRange(undefined)
      }
      // Reset default date range once inputs value is empty and dateRange is undefined
      if (!searchValue && !dateRange) {
        setDateRange(getDefaultRange())
      }
    }, 300)

    return () => clearInterval(interval)
  }, [searchValue, setSearchQuery, dateRange, setDateRange])

  const onSearchChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) =>
    setSearchValue(value)

  return (
    <Div className={styles.headerBarContainer}>
      <Div className={styles.headerBarWrapper}>
        <Div className={styles.headerBarLeft}>
          <Div className={styles.headerBarTitle}>{activeFilter?.name || 'All accounts'}</Div>
          <Div className={styles.headerBarIcon}>
            <ToolTip flow="down" tethered render={() => 'Filters'}>
              <IconButton onClick={() => setShowFiltersCard(!showFiltersCard)} icon="pb-filter" />
            </ToolTip>
          </Div>
          <Div className={styles.headerBarIcon}>
            <ToolTip flow="down" tethered render={() => 'Manage notifications'}>
              <Link to={`?savedFilterId=${activeFilter?.id}#notificationSettings`}>
                <IconButton icon="notification" />
              </Link>
            </ToolTip>
          </Div>
        </Div>
        <Input
          className={styles.searchInput}
          type="search"
          placeholder="Search by account name..."
          size="large"
          defaultValue={searchQuery}
          onChange={onSearchChange}
        />
        {showFiltersCard && (
          <CCRMFiltersCard
            onClose={() => setShowFiltersCard(false)}
            onOpenEditModal={props.onOpenEditModal}
            setActiveFilterId={props.setActiveFilterId}
          />
        )}
      </Div>
    </Div>
  )
}

export default CCRMHeaderBar
